import React, { Component } from 'react';
import { connect } from 'react-redux';
import { iconEmpty } from './../../../../../services/helper';
import Row from './../row';

class Rows extends Component {
    renderRow = () => {
        if (this.props.shipments.length) {
            let shipmentNew = []
            for (let i = 0; i < this.props.shipments.length; i++) {
                let packageInfo = []
                if (this.props.shipments[i].StatusID !== 1) {
                    packageInfo.push(
                        <div key={i}>
                            <span>{(this.props.shipments[i].GrossWeightFL || this.props.shipments[i].VolumeWeightFL)
                                ? (this.props.shipments[i].GrossWeightFL >= this.props.shipments[i].VolumeWeightFL)
                                    ? this.props.shipments[i].GrossWeightFL : this.props.shipments[i].VolumeWeightFL : 0} &nbsp;</span>
                            <span>{this.props.shipments[i].WeightUnitCH} &nbsp;<br /></span>
                            {this.props.shipments[i].LengthFL ? <span>{this.props.shipments[i].LengthFL}</span> : ''}
                            {this.props.shipments[i].WidthFL ? <span>&nbsp;x&nbsp;{this.props.shipments[i].WidthFL}</span> : ''}
                            {this.props.shipments[i].HeightFL ? <span>&nbsp;x&nbsp;{this.props.shipments[i].HeightFL}</span> : ''}
                            {this.props.shipments[i].LengthFL ? <span>&nbsp;{this.props.shipments[i].LengthUnitCH}</span> : ''}
                        </div>
                    )
                } else packageInfo.push(null)
                let shipmentCurrent = this.props.shipments[i]
                let obj = {}
                obj[shipmentCurrent.key] = shipmentCurrent.PackageID
                let trackingNoUrl = 'https://www.yamatoamerica.com/tracking/?slipnumber=' + this.props.shipments[i].TrackingNumberCH
                shipmentNew.push(
                    <Row
                        trackingNoUrl={trackingNoUrl}
                        i={i}
                        key={i}
                        obj={obj}
                        packageInfo={packageInfo}
                        shipperInformation={this.props.shipperInformation}
                    />
                )
            }
            return shipmentNew
        } else {
            return (
                <tr style={{ width: '100%', textAlign: 'center' }}>
                    <td colSpan={8}>{iconEmpty()}</td>
                </tr>
            )
        }
    }

    render() {
        return (
            <tbody>
                {this.renderRow()}
            </tbody>
        );
    }
}

const mapStateToProps = state => {
    return {
        shipments: state.shipmentReducer.shipments,
        shipperInformation: state.shipmentReducer.shipperInformation
    }
}

export default connect(
    mapStateToProps,
    null
)(Rows)


// WEBPACK FOOTER //
// ./src/containers/shipments/list/components/rows/index.js